export const day_data = [{
		value: '2',
		label: '周一',
	},
	{
		value: '3',
		label: '周二',

	},
	{
		label: '周三',
		value: '4'
	},
	{

		label: '周四',
		value: '5'
	},
	{

		label: '周五',
		value: '6'
	},
	{

		label: '周六',
		value: '7'
	},
	{
		label: '周日',
		value: '1'
	},
	{
		label: '每天',
		value: '8'
	}
]
export const cascader_week = [{
	value: '8',
	label: '每天',
}, {
	value: 'week',
	label: '每周',
	children: [{
			value: '2',
			label: '周一',
		},
		{
			value: '3',
			label: '周二',

		},
		{
			label: '周三',
			value: '4'
		},
		{

			label: '周四',
			value: '5'
		},
		{

			label: '周五',
			value: '6'
		},
		{

			label: '周六',
			value: '7'
		},
		{
			label: '周日',
			value: '1'
		},
	]
}]

// 话术选择 包含全部、节假日话术、以及系统话术类型
export const msgTypeOptions = [
		{name:'节假日',id:'holiday'},
		{name:'开场白',id:'addNewAgent'},
		{name:'满意度',id:'satisfaction'},
		{name:'闭线',id:'closeTime'},
		{name:'排队',id:'queue'},
		{name:'忙线',id:'allBusy'},
		{name:'留言',id:'leaveMsgTemplete'},
		{name:'长时间未响应',id:'autoClose'},
		{name:'转接欢迎语',id:'addNewAgentForTransfer'},
		{name:'结束语',id:'endSessionMsg'},
		{name:'用户退出会话',id:'customerLeave'}
]
// 微信绑定类型
export const chat_type = [
  {		
	   title:'绑定后你可以使用OCS+统一接收与回复顾客咨询',
		desc:`你的公众号必须是认证过的微信订阅号/服务号`,
		btn:'绑定公众号',
		icon:'major-weixin',
		visible:false,
		type:1,
		key:'绑定微信公众号',
		link:'https://developers.weixin.qq.com/doc/offiaccount/Basic_Information/Access_Overview.html'
},{
		title:'绑定后你可以使用OCS+统一接收与回复顾客咨询',
		desc:`你的小程序必须是认证过的微信小程序`,
		btn:'绑定小程序',
		icon:'major-weixinxiaochengxu',
		visible:false,
		type:2,
		link:'https://developers.weixin.qq.com/miniprogram/dev/framework/server-ability/message-push.html#option-url',
		key:'绑定微信小程序'}
]

// 消息处理模式
export const messageHandleTypeObj = {
	'Test':['授权'],
	'Forward':['普通模式'],
	'Keyword':['关键词模式'],
	'MenuEvent':['事件模式']
}
// 绑定状态
export const messageHandleStatus = {
	'0':'未授权',
	'1':'已授权',
	'2':'已解绑',
}
// 字段管理-字段类型
export const custerTypes = {
	'input':['单行文本'],
	'droplist':['下拉列表'],
	'date':['日期'],
	'time':['时间'],
	'datetime':['日期时间'],
	'numerical':['数值'],
	'integer':['正整数'],
	'link':['链接'],
	'cascade':['级联'],
	'radio':['单选'],
	'checkbox':['多选'],
	'text':['多行文本'],
	'file':['附件'],
}
// 聊天功能配置
export const chatSystemLists = [
	{
		scene:'忙线',
		name:'忙线转排队',
		descrption:`<p>开启后，工作时间坐席忙线时，用户进线后进入排队流程；</p><p>关闭后，无排队流程；</p>`,
		operate:'swicth',
		enabled:false,
		id:1016,
		muta_index:'1'
	},{
		scene:'',
		name:'忙线转留言',
		descrption:'<p>开启后，工作时间坐席忙线时，用户可留言（同时会产生1条弃线-坐席全忙）</p><p>关闭后，忙线直接算弃线，没有留言功能；</p>',
		operate:'swicth',
		enabled:false,
		id:1015,
		muta_index:'0'
	},{
		scene:'排队',
		name:'加入排队确认',
		descrption:'<p>开启后，排队前需要客户确认</p>',
		operate:'swicth',
		enabled:true,
		id:20000,
		children:[
			{
				name:'确认排队 响应时间',
				descrption:'当系统发送 确认加入队列 的话术类型时（例，您前面的排队人数剩余${nums}，请问您是否开始排队？排队请输入“1”），若客人超时未响应，将视为放弃排队',
				key:'autoCloseUnconfirmJoinQueueTime'
			}
		]
	},{
		scene:'排队',
		name:'排队人数+1',
		descrption:'<p>开启后，前方排队数从1开始计数，即 队首收到的排队话术提示为“前方还有1人”，而非“前方还有0人”；</p>',
		operate:'swicth',
		enabled:false,
		id:2004
	},{
		scene:'进线',
		name:'客人到号需确认',
		descrption:'<p>开启后，排队到号进线需要确认，超出响应时间则视为过号弃线；</p><p>关闭后，客人排队到号后无需确认，自动进线；</p>',
		operate:'swicth',
		enabled:false,
		id:20002,
		children:[
			{
				name:'客人过号 响应时间',
				descrption:'当系统发送 确认接入会话 的话术类型时（例，您现在可以接入客服，确定接入客服，请在30秒内回复”1“），若客人超时未响应，将视为放弃接入会话',
				key:'autoCloseUnconfirmJoinSessionTime'
			}
		]
	},{
		scene:'会话中',
		name:'客户输入预览',
		descrption:'<p>开启后，坐席可以同步预览到来自官网渠道的客户正在输入还未发送的聊天信息</p>',
		operate:'swicth',
		enabled:false,
		id:1005,
	},{
		scene:'关闭会话',
		name:'自动关闭会话',
		descrption:'客户发送一条消息后，CSR（坐席）如果超出预设的时间仍未回复，会话将自动关闭',
		key:'autoCloseSessionTimeOfCustomer',
		label:'CSR未响应,会话关闭时间'
		
	},{
		scene:'',
		name:'',
		descrption:'CSR发送一条消息后，客户如果超出预设的时间仍未回复，会话将自动关闭',
		key:'autoCloseSessionTimeOfAgent',
		label:'客人未响应,会话关闭时间'
	},{
		scene:'关闭会话',
		name:'沟通小结必填',
		descrption:'开启后，填写沟通小结保存后才可关闭会话',
		operate:'swicth',
		enabled:false,
		id:1008,
	},{
		scene:'满意度',
		name:'满意度调查',
		descrption:'<p>自动：在会话结束时，系统自动发送邀请满意度评价；</p><p>手动：在会话结束前，IM进线窗口提供按钮，点击后发送邀请满意度评价</p>',
		operate:'radio',
		key:'autoSendScorePage',
		enabled:true,
		children:[
			{
				name:'满意度地址：',
				key:'scorePageUrl',
			}
		]
	},{
		scene:'留言',
		name:'留言板',
		descrption:'<p>开启后，用户在闭线时间或工作时间坐席忙线（需要开启忙线转留言）发起咨询时，用户可留言</p>',
		operate:'swicth',
		enabled:false,
		id:1010,
		children:[
			{
				name:'留言自动关闭时间',
				descrption:'客人进入留言界面，如果超出限定时间不留言，系统将自动关闭留言窗口',
				key:'autoCloseLeaveMsgTime'
			}
		]
	},{
		scene:'闭线',
		name:'闭线后，清除排队用户',
		descrption:'<p>开启后，闭线时间一到，所有排队用户被清除，即客服打样，不再接待客户，同时系统自动发送闭线话术；</p><p>关闭后，尽管闭线时间到，坐席仍需加班处理剩余排队用户</p>',
		operate:'swicth',
		enabled:false,
		id:1013,
	},{
		scene:'闭线',
		name:'发送长时间未响应系统话术',
		descrption:'',
		operate:'swicth',
		enabled:false,
		id:1105,
		hidden:true
	},{
		scene:'未知',
		name:'微信unionid',
		descrption:'开启后，微信&小程序渠道会根据unionid识别客户 ',
		operate:'swicth',
		enabled:false,
		id:2006,
		hidden:true
	},{
		scene:'未知',
		name:'图文',
		descrption:'开启后，支持图文发送',
		operate:'swicth',
		enabled:false,
		id:6001,
		hidden:true
	},{
		scene:'未知',
		name:'视频',
		descrption:'开启后，支持视频发送',
		operate:'swicth',
		enabled:false,
		id:6004,
		hidden:true
	},{
		scene:'未知',
		name:'语音',
		descrption:'开启后，支持语音发送',
		operate:'swicth',
		enabled:false,
		id:6005,
		hidden:true
	},{
		scene:'未知',
		name:'小程序卡片',
		descrption:'开启后，支持小程序卡片发送',
		operate:'swicth',
		enabled:false,
		id:6006,
		hidden:true
	}
	
]